import { AcademyId } from '../../types/academy';

// Operational credentials: never display or log these values.
export const TV_ACCESS_CODES: Record<AcademyId, string> = {
  BLC: 'BLCTVCODE',
  KTA: 'KTATVCODE'
};
